import { getFirstImage, getProductPrices, calculatePrice } from "../../utils/cartHelper";

export const addCartAction =
  ({ product, quantity, selectedPrice }) =>
  (dispatch, getState) => {
    const priceType = product.priceType;

    const cartKey = `${product.id}-${
      selectedPrice?.unitType ?? "U"
    }-${selectedPrice?.unitValue ?? "U"}`;

    const { basePrice, discountedPrice } = calculatePrice(product, selectedPrice, quantity);

    dispatch({
      type: "ADD_CART",
      payload: {
        cartKey,
        productId: product.id,
        quantity,
        priceType,
        unitType: selectedPrice?.unitType ?? null,
        unitValue: selectedPrice?.unitValue ?? null,

        // display fields — populated immediately so the item
        // renders correctly before the DB refresh runs
        title: product.title || "",
        image: getFirstImage(product.image),
        description: product.description || "",
        basePrice: product.basePrice ?? 0,
        prices: getProductPrices(product),
        offer: product.offer || null,
        selectedPrice: selectedPrice ?? null,
        currentBasePrice: basePrice,
        discountedPrice,
      },
    });

    const {
      cart: { cartItems },
    } = getState();

    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  };


// Update quantity
export const updateCartQtyAction =
  (cartKey, action) => (dispatch, getState) => {
    dispatch({
      type: "CART_UPDATE_QTY",
      payload: {
        cartKey,
        action,
      },
    });

    const {
      cart: { cartItems },
    } = getState();

    localStorage.setItem(
      "cartItems",
      JSON.stringify(cartItems)
    );
  };


// Update cart items with latest database information
export const updateCartItemsAction =
  (cartItems) => (dispatch, getState) => {
    dispatch({
      type: "UPDATE_CART_ITEMS",
      payload: cartItems,
    });

    const {
      cart: { cartItems: updatedCartItems },
    } = getState();

    localStorage.setItem(
      "cartItems",
      JSON.stringify(updatedCartItems)
    );
  };


// Remove from cart
export const removeCartAction =
  (cartKey) => (dispatch, getState) => {
    dispatch({
      type: "REMOVE_CART",
      payload: cartKey,
    });

    const {
      cart: { cartItems },
    } = getState();

    localStorage.setItem(
      "cartItems",
      JSON.stringify(cartItems)
    );
  };


// Clear cart
export const clearCartAction =
  () => (dispatch, getState) => {
    dispatch({
      type: "CLEAR_CART",
    });

    const {
      cart: { cartItems },
    } = getState();

    localStorage.setItem(
      "cartItems",
      JSON.stringify(cartItems)
    );
  };